// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xh07U3v1_DFop0XkT8q8{gap:8px}.xh07U3v1_DFop0XkT8q8>div{align-items:flex-start}`, "",{"version":3,"sources":["webpack://./src/pages/clickToText/pages/createClickToText/ui/ClickToTextFields/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,OAAA,CAGF,0BACE,sBAAA","sourcesContent":[".name {\n  gap: 8px;\n}\n\n.name > div {\n  align-items: flex-start;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"name": `xh07U3v1_DFop0XkT8q8`
};
export default ___CSS_LOADER_EXPORT___;
